import React from "react";

export default function TFJS_Tutorial() {
  return (
    <div>
      <h1>TFJS_Tutorial</h1>
      <p>This is the TFJS_Tutorial component.</p>
    </div>
  );
}
